import * as Yup from 'yup';
import * as React from 'react';
import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
// mui
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';
import InputAdornment from '@mui/material/InputAdornment';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
// auth
import { useAuthContext } from 'src/auth/hooks';
import { handleApiAction } from 'src/utils/handleApiAction';
// components
import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
// context
import { FormShareContext, ModificationContext, typeIDContext } from 'src/context/Context';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { resetPassword } from 'src/components/userSetting/api/services';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ModalResetPassWord = ({ width = 'md' }) => {


  const { user, logout } = useAuthContext();
  
  const formUrl = useContext(typeIDContext);
  const share = useContext(FormShareContext);
  const modal = useContext(ModificationContext);

  const navigate = useNavigate();

  const password = useBoolean();
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [allert, setAllert] = useState('succes');

  const ChangePassWordSchema = Yup.object().shape({
    new_password: Yup.string()
      .required('Un nouveau mot de passe est requis')
      .min(6, 'Minimum 6 caractères'),
    new_password_confirmation: Yup.string().oneOf(
      [Yup.ref('new_password')],
      'Les mots de passe doivent correspondre.'
    ),
  });

  const defaultValues = {
    new_password: '',
    new_password_confirmation: '',
  };

  const methods = useForm({
    resolver: yupResolver(ChangePassWordSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  const handleResetPassword = (data, userID) =>
  {      
    const payload = { ...data, userID };

    handleApiAction({
        action: resetPassword,
        payload,
        onSuccess: () => { 
          reset();
          setError(false);
          setAllert('succes')
          share.updateFormShare(false);

          const rawParams = localStorage.getItem('params');
          const params = rawParams ? JSON.parse(rawParams) : null;

          if(user.activation === 0){  
            modal.updateModification(true); 
          }else if(formUrl.typeID && String(user.id) === String(params?.traineeID) ){
            navigate(formUrl.typeID);
            formUrl.updateTypeID(null);
            localStorage.removeItem('params');
          }else{
            formUrl.updateTypeID(null);
            localStorage.removeItem('params');
          }
        },
        enqueueSnackbar,
        logout,
    });
  }

  const onSubmit = handleSubmit(async (data) => {
    handleResetPassword(data, user.id);
  });

  const handleClose = () => {
    share.updateFormShare(false);
  };

  useEffect(() => {
    setError(false);
  }, [values.new_password, values.new_password_confirmation]);

  return (
    <Dialog
      open={share.showFormShare}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={width}
      keepMounted
       onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
      aria-describedby="alert-dialog-slide-description"
      disableEscapeKeyDown
    >
      <DialogTitle>Nouveau mon mot de passe</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity={allert} sx={{ mb: 3 }}>
            {message}
          </Alert>
        )}

        <FormProvider methods={methods} onSubmit={onSubmit}>
          <Stack spacing={3} sx={{ p: 3 }}>

            <RHFTextField
              name="new_password"
              label="Nouveau mot de passe"
              type={password.value ? 'text' : 'password'}
              InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={password.onToggle} edge="end">
                    <Iconify icon={password.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
              helperText={
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <Iconify icon="eva:info-fill" width={16} />
                  <span>Minimum 6 caractères</span>
                </Stack>
              }
            />

            <RHFTextField
              name="new_password_confirmation"
              type={password.value ? 'text' : 'password'}
              label="Confirmer le nouveau mot de passe"
              InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={password.onToggle} edge="end">
                    <Iconify icon={password.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}

            />
          </Stack>
        </FormProvider>
      </DialogContent>

      <DialogActions>
      {/*   <Button onClick={handleClose}>Fermer</Button> */}
        <LoadingButton
          type="submit"
          color="inherit"
          variant="contained"
          loading={isSubmitting}
          onClick={onSubmit}
        >
          Enregistrer
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

ModalResetPassWord.propTypes = {
  width: PropTypes.string,
};

export default ModalResetPassWord;
